import React from 'react';
import TMLogoBlueSVG from './svg/TMLogoBlueSVG';
import TMLogoIndigoSVG from './svg/TMLogoIndigoSVG';
import TMLogoWhiteSVG from './svg/TMLogoWhiteSVG';

export type ColorVariant = 'primary' | 'secondary' | 'white';

export interface CompanyLogoSVGProps extends React.SVGProps<SVGSVGElement> {
    color?: ColorVariant;
}

export const CompanyLogo = ({ width = '256px', height = '48px', ...rest }: CompanyLogoSVGProps) => {
    const { color, ...props } = { width, height, ...rest };

    switch (color) {
        case 'white':
            return <TMLogoWhiteSVG {...props} />;
        case 'secondary':
            return <TMLogoIndigoSVG {...props} />;
        case 'primary':
        default:
            return <TMLogoBlueSVG {...props} />;
    }
};
